export default "__VITE_ASSET__599a2df1__"